import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { OlapicWidget } from '@ori/olapic-lib';
import { GetTenantApplicationsOlapicConfigurationOlapicType } from '@ori/static-api-client-react';
import React from 'react';
import { Layout } from '~/containers/Layout';
const GalleryPage = (param)=>{
    let { layoutPage } = param;
    return /*#__PURE__*/ _jsx(Layout, {
        layoutPage: layoutPage,
        children: /*#__PURE__*/ _jsx(OlapicWidget, {
            type: GetTenantApplicationsOlapicConfigurationOlapicType.Gallery
        })
    });
};
export var __N_SSG = true;
export default GalleryPage;
